exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_wks-ext.js
// module id = 185
// module chunks = 92